import http from "../components/http";
import { Colaborador } from "../interfaces/colaborador.interface";

// Buscar todos os colaboradores
export const fetchColaboradores = async (): Promise<Colaborador[]> => {
    const response = await http.get(`/colaboradores`);
    return response.data;
};

// Buscar um colaborador por ID
export const fetchColaborador = async (id: string): Promise<Colaborador> => {
    const response = await http.get(`/colaboradores/${id}`);
    return response.data;
};

// Criar um novo colaborador
export const createColaborador = async (colaborador: Colaborador): Promise<Colaborador> => {
    let response;
    try {
        response = await http.post(`/colaboradores`, colaborador);
    } catch (error) {
        console.error("Erro ao criar colaborador:", error);
    }
    return response?.data;
};

// Atualizar um colaborador existente
export const updateColaborador = async (id: string, colaborador: Colaborador): Promise<Colaborador> => {
    const response = await http.put(`/colaboradores/${id}`, colaborador);
    return response.data;
};

// Deletar um colaborador
export const deleteColaborador = async (id: string): Promise<void> => {
    await http.delete(`/colaboradores/${id}`);
};
